<template>
  <div class="cm-checkbox">
    <label>
      <input
        type="checkbox"
        @change="$emit('input', $event.target.checked)"
        :checked="checked"
        />
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  model: {
    prop: "checked"
  },

  props: {
    checked: {
      type: Boolean
    },
    label: {
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
.cm-checkbox {
  label {
    display: inline-block;
    input {
      margin-right: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/checkbox.vue?193f903a